import React, { useEffect, useState, useCallback } from 'react';
import { FaInstagram } from 'react-icons/fa';
import '../assets/css/InstagramFeed.css';

const InstagramFeed = () => {
  const [screenWidth, setScreenWidth] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  // Handle responsive behavior
  const handleResize = useCallback(() => {
    const width = window.innerWidth;
    setScreenWidth(width);
    setIsMobile(width <= 767);
    setIsTablet(width >= 768 && width <= 991);
  }, []);

  useEffect(() => {
    const handleOrientationChange = () => {
      setTimeout(handleResize, 100);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, [handleResize]);

  useEffect(() => {
    // Load Elfsight platform script if not already loaded
    if (!document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://static.elfsight.com/platform/platform.js';
      script.async = true;
      document.head.appendChild(script);
      
      console.log('Elfsight Instagram Feed script loaded');
    }

    // Function to hide watermark elements
    const hideWatermark = () => {
      // Wait for widget to load
      setTimeout(() => {
        const container = document.querySelector('.elfsight-app-7960534f-d701-4172-972d-92afe1454f7d');
        if (container) {
          // Hide elements by text content
          const allElements = container.querySelectorAll('*');
          allElements.forEach(element => {
            const text = element.textContent || element.title || element.getAttribute('aria-label') || '';
            if (text.toLowerCase().includes('free instagram feed widget') || 
                text.toLowerCase().includes('powered by elfsight') ||
                element.href && element.href.includes('elfsight.com')) {
              element.style.display = 'none';
              element.style.visibility = 'hidden';
              element.style.opacity = '0';
              element.style.height = '0';
              element.style.width = '0';
              element.style.overflow = 'hidden';
            }
          });

          // Hide common watermark selectors
          const watermarkSelectors = [
            '[class*="branding"]',
            '[class*="watermark"]',
            '[class*="powered"]',
            'a[href*="elfsight.com"]',
            '[title*="Free Instagram Feed widget"]',
            '[aria-label*="Free Instagram Feed widget"]',
            'div[style*="position: absolute"][style*="bottom"]',
            'div[style*="position: fixed"][style*="bottom"]'
          ];

          watermarkSelectors.forEach(selector => {
            const elements = container.querySelectorAll(selector);
            elements.forEach(el => {
              el.style.display = 'none !important';
            });
          });
        }
      }, 2000);

      // Repeat check every few seconds for dynamically loaded content
      setTimeout(hideWatermark, 5000);
    };

    // Start hiding watermark
    hideWatermark();
  }, []);

  // Handle touch events for mobile
  const handleTouchStart = (e) => {
    if (!isMobile) return;
    e.currentTarget.classList.add('touching');
  };

  const handleTouchEnd = (e) => {
    if (!isMobile) return;
    setTimeout(() => {
      e.currentTarget.classList.remove('touching');
    }, 150);
  };

  return (
    <div className={`instagram-feed ${isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'}`}>
      <div className="instagram-header">
        <h2 className="intagram_heading">
          {isMobile ? '#Instagram' : '#Instagram'}
        </h2>
        <p className="section-subtitle">
          {isMobile 
            ? 'Follow our latest designs and projects'
            : 'Stay updated with our latest designs and projects'
          }
        </p>
        <a 
          href="https://www.instagram.com/designcraft.ae/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="follow-btn"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <FaInstagram /> 
          {isMobile ? 'Follow Us' : 'Follow @designcraft.ae'}
        </a>
      </div>

      {/* Elfsight Instagram Feed Widget */}
      <div className="elfsight-instagram-container">
        <div 
          className="elfsight-app-7960534f-d701-4172-972d-92afe1454f7d" 
          data-elfsight-app-lazy
        ></div>
      </div>

      {/* <div className="instagram-footer">
        <a 
          href="https://www.instagram.com/designcraft.ae/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="view-more-btn"
        >
          <FaInstagram /> View More on Instagram
        </a>
      </div> */}
    </div>
  );
};

export default InstagramFeed; 